"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ZoneMetricCategory;
(function (ZoneMetricCategory) {
    ZoneMetricCategory["Attractiveness"] = "attractiveness";
    ZoneMetricCategory["ROI"] = "roi";
    ZoneMetricCategory["Performance"] = "performance";
    ZoneMetricCategory["Interaction"] = "interaction";
    ZoneMetricCategory["Heatmap"] = "heatmap";
})(ZoneMetricCategory = exports.ZoneMetricCategory || (exports.ZoneMetricCategory = {}));
var ZoneMetricId;
(function (ZoneMetricId) {
    ZoneMetricId["AttractivenessRate"] = "attractivenessRate";
    ZoneMetricId["AverageRevenueAfterClick"] = "averageRevenueAfterClick";
    ZoneMetricId["AvgConversionAfterClick"] = "avgConversionAfterClick";
    ZoneMetricId["AvgConversionAfterHover"] = "avgConversionAfterHover";
    ZoneMetricId["AvgHoverTime"] = "avgHoverTime";
    ZoneMetricId["AvgTransactionAfterClick"] = "avgTransactionAfterClick";
    ZoneMetricId["AvgTransactionAfterHover"] = "avgTransactionAfterHover";
    ZoneMetricId["ClickRate"] = "clickRate";
    ZoneMetricId["ClickRepetition"] = "clickRepetition";
    ZoneMetricId["ClickDistribution"] = "clickDistribution";
    ZoneMetricId["ConversionAfterClick"] = "conversionAfterClick";
    ZoneMetricId["ConversionAfterHover"] = "conversionAfterHover";
    ZoneMetricId["EngagementRate"] = "engagementRate";
    ZoneMetricId["EngagementRateLive"] = "engagementRateLive";
    ZoneMetricId["ExposureRate"] = "exposureRate";
    ZoneMetricId["ExposureTime"] = "exposureTime";
    ZoneMetricId["Hesitation"] = "hesitation";
    ZoneMetricId["HoverRate"] = "hoverRate";
    ZoneMetricId["HoverTime"] = "hoverTime";
    ZoneMetricId["SessionsWithClick"] = "sessionsWithClick";
    ZoneMetricId["SessionsWithHover"] = "sessionsWithHover";
    ZoneMetricId["TimeBeforeFirstClick"] = "timeBeforeFirstClick";
    ZoneMetricId["TotalClicks"] = "totalClicks";
    ZoneMetricId["TotalConversionAfterClick"] = "totalConversionAfterClick";
    ZoneMetricId["TotalConversionAfterHover"] = "totalConversionAfterHover";
    ZoneMetricId["TotalHovers"] = "totalHovers";
    ZoneMetricId["TotalHoverTime"] = "totalHoverTime";
    ZoneMetricId["TotalRevenueAfterClick"] = "totalRevenueAfterClick";
    ZoneMetricId["TransactionCountWithClick"] = "transactionCountWithClick";
    ZoneMetricId["TransactionCountWithHover"] = "transactionCountWithHover";
    ZoneMetricId["ViewWithClick"] = "viewWithClick";
    ZoneMetricId["ViewWithHover"] = "viewWithHover";
    ZoneMetricId["AverageRevenueAfterTap"] = "revenuePerTap";
    ZoneMetricId["ConversionAfterTap"] = "conversionRatePerTap";
    ZoneMetricId["ConversionRatePerDrag"] = "conversionRatePerDrag";
    ZoneMetricId["ConversionRatePerFlick"] = "conversionRatePerFlick";
    ZoneMetricId["ConversionRatePerSwipe"] = "conversionRatePerSwipe";
    ZoneMetricId["TransactionAfterTap"] = "transactionRatePerTap";
    ZoneMetricId["DragFlickRate"] = "dragFlickRate";
    ZoneMetricId["DragFlickRecurrence"] = "dragFlickRecurrence";
    ZoneMetricId["DragRate"] = "dragRate";
    ZoneMetricId["DragRecurrence"] = "dragRecurrence";
    ZoneMetricId["FlickRate"] = "flickRate";
    ZoneMetricId["FlickRecurrence"] = "flickRecurrence";
    ZoneMetricId["TapCount"] = "tapCount";
    ZoneMetricId["TapRate"] = "tapRate";
    ZoneMetricId["TapRecurrence"] = "tapRecurrence";
    ZoneMetricId["TapDistribution"] = "tapDistribution";
    ZoneMetricId["TimeBeforeFirstTap"] = "timeBeforeFirstTap";
    ZoneMetricId["TotalRevenueAfterTap"] = "totalRevenueWithTap";
    ZoneMetricId["SwipeRate"] = "dragFlickRate";
    ZoneMetricId["SwipeRecurrence"] = "dragFlickRecurrence";
})(ZoneMetricId = exports.ZoneMetricId || (exports.ZoneMetricId = {}));
//# sourceMappingURL=zone.metric.js.map